import { Injectable } from '@angular/core';
import { AgentReportApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { AgentReportAction } from '../actions';

@Injectable()
export class AgentReportEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(AgentReportAction.loadItem),
      exhaustMap(action => {
        return this._apiService.get(action.id).pipe(map(item => AgentReportAction.loadItemSuccess({ item })));
      })
    );
  });
  constructor(private _apiService: AgentReportApiService, private _actions$: Actions, private _store: Store) {}
}
